import { createFileRoute } from '@tanstack/react-router'
import { FounderPitchDetail } from '../../../features/pitch/components/founder-pitch-detail'
import { InvestorPitchDetail } from '../../../features/pitch/components/investor-pitch-detail'
import { useIsFounder } from '../../../hooks/use-user-type'

export const Route = createFileRoute('/_protected/pitches/$pitchId')({
  component: PitchDetailRoute,
})

function PitchDetailRoute() {
  const { pitchId } = Route.useParams()
  const isFounder = useIsFounder()

  return isFounder ? (
    <FounderPitchDetail pitchId={pitchId} />
  ) : (
    <InvestorPitchDetail pitchId={pitchId} />
  )
}
